import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Homepage from "./pages/Homepage";
import Demo from "./pages/Demo";
import Contact from "./pages/Contact";
import AboutUs from "./pages/AboutUs";
import SuccessCases from "./pages/SuccessCases";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/demo" element={<Demo />} />
          <Route path="/contacto" element={<Contact />} />
          <Route path="/sobre-nosotros" element={<AboutUs />} />
          <Route path="/casos-exito" element={<SuccessCases />} />
          <Route path="/politica-privacidad" element={<PrivacyPolicy />} />
          <Route path="/terminos-uso" element={<TermsOfUse />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;